import styled from 'styled-components';

export const BIContainer = styled.div`
  display: flex;
  gap: 20px;
`;

export const BICard = styled.div`
  background: white;
  padding: 10px 15px;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  min-width: 150px;
  label {
    display: block;
    font-size: 12px;
    color: #718096;
    text-transform: uppercase;
    margin-bottom: 4px;
  }
  .value {
    font-size: 16px;
    font-weight: bold;
    color: #2d3748;
  }
  .footer {
    font-size: 12px;
    margin-top: 5px;
    color: #4a5568;
  }
`;
